import Vue from "../main";
import { addAddressService, addPaymentMethodService, addShippingService, getAddressesService, getPaymentMethodsService, getRegionsService, getShippingOptionsService } from "../services/shippingService";
import {  getCartItemsAndCartSummary, getCartSummary } from "./manageCart";

export async function addPaymentMethod(paymentMethodId) {   
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await addPaymentMethodService({
        "carrelloId": carrelloId,
        "metodopagamentoId": paymentMethodId,
    });

    if (!res || res.error) {
      throw new Error(res.message || "Failed to add payment method.");
    }

    let cartSummary = await getCartSummary();

    $store.dispatch("updateCartSummary", cartSummary);
    return true;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}

export async function getPaymentMethods() {   
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await getPaymentMethodsService();

    if (!res || res.error) {
      throw new Error(res.message || "Failed to get payment methods.");
    }
    return res;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}
export async function addAddress(address) {   
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await addAddressService({
        "carrelloId": carrelloId,
        "indirizzoSpedizione": address,
      });

    if (!res || res.error) {
      throw new Error(res.message || "Failed to add address.");
    }

    let cartSummary = await getCartSummary();

    $store.dispatch("updateCartSummary", cartSummary);
    return true;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}
export async function getShippingOptions(region) {   
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await getShippingOptionsService({
      "carrelloId": carrelloId,
      "regioneId": region
    });

    if (!res || res.error) {
      throw new Error(res.message || "Failed to get shipping options.");
    }
    return res;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}
export async function getRegions(perPage = 10, currentPage = 1) {
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await getRegionsService({
      "limit": perPage,
      "page": currentPage
    });

    if (!res || res.error) {
      throw new Error(res.message || "Failed to get regions.");
    }
    return res;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}

export async function getAddresses() {
  const {
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }

    var res = await getAddressesService({
      "carrelloId": carrelloId,
    });

    if (!res || res.error) {
      throw new Error(res.message || "Failed to get addresses.");
    }
    return res;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}
export async function addShipping(shippingOptions) {
  const {
    $store,
    $toast,
  } = Vue._context.config.globalProperties;

  try {
    let carrelloId = localStorage.getItem("carrelloId");
    if (!carrelloId || carrelloId === "undefined") {
      $toast.error("Cart is empty.");
      return false;
    }
    if (!shippingOptions || shippingOptions.length === 0) {
      $toast.error("Shipping options are required.");
      return false;
    }
    
    let shippingData = Object.entries(shippingOptions).map(([key, value]) => ({ elementoId: key, opzioneId: value }));
    
    var res = await addShippingService({
      "carrelloId" : carrelloId,
      "opzioniSpedizione": [...shippingData]
    });
    
    if (!res || res.error) {
      throw new Error(res.message || "Failed to get addresses.");
    }
    let {cartSummary, cartItems} = await getCartItemsAndCartSummary();
    $store.dispatch("updateCartSummary", cartSummary);
    $store.dispatch("updateAllCartItems", cartItems);
    return res;
  } catch (error) {
    let message = "An error has occurred.";
    if (error.message) {
      message = error.message;
    }
    $toast.error(message);
    return false;
  }
}